import { useSelector } from 'react-redux';
import { language, translator } from './selectors';
const useTranslator = () => useSelector(translator);
const useLanguage = () => useSelector(language);
export { useLanguage, useTranslator };
